require( './dependencies.js');
require( './sass/style.scss');

//include js and css
// todo add code to make sure there is a file before running (then remoove empty files)
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./js/', true, /\.js$/));
requireAll(require.context('./css/', true, /\.css$/));
requireAll(require.context('./svg/', true, /\.(gif|jpg|png|svg)$/));
